module.exports = __webpack_public_path__ + "static/media/add-content.0a5f0773.svg";